import axios from "axios";
import { toast } from "react-toastify";

export const getClubLeaderboard = async (clubID, token, data) => {
  // "";
  try {
    let year, month;

    if (data?.year) {
      year = data.year;
    } else if (data?.month) {
      month = data.month;
    }
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/clubs/getAllGoals/${clubID}?year=${year}&month=${month}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.data || null;
  } catch (error) {
    toast.error("error fetching leaderboard!!");
    return null;
    // throw new Error(error.message);
  }
};
